@if (link) {
  <a
    [routerLink]="link"
    class="bg-foreground rounded-xl border border-divider p-4 flex flex-col gap-2 h-full hover:shadow-md transition-shadow cursor-pointer">
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </a>
} @else {
  <div
    class="bg-foreground rounded-xl border border-divider p-4 flex flex-col gap-2 h-full">
    <ng-container *ngTemplateOutlet="cardContent"></ng-container>
  </div>
}

<ng-template #cardContent>
  <div class="flex items-center justify-between">
    <span class="text-xs text-secondary font-medium">{{ label }}</span>
    <div
      class="w-8 h-8 rounded-lg flex items-center justify-center"
      [class]="colorClass">
      <mat-icon
        [svgIcon]="icon"
        class="w-4 h-4"
        style="font-size: 18px"></mat-icon>
    </div>
  </div>

  @if (isLoading(item)) {
    <div class="h-8 w-24 bg-base rounded animate-pulse"></div>
  } @else if (isError(item)) {
    <app-widget-error
      appClickStopPropagation
      (retry)="retry.emit()"></app-widget-error>
  } @else {
    <p class="text-2xl font-bold text-default">{{ value }}{{ suffix }}</p>
  }

  @if (link) {
    <div class="flex items-center gap-1 text-xs text-primary-600 mt-auto">
      <span>View details</span>
      <mat-icon
        svgIcon="mat:chevron_right"
        class="w-3 h-3"
        style="font-size: 14px"></mat-icon>
    </div>
  }
</ng-template>
